import api from './axios';

export async function fetchNotifications(id) {
  // backend returns { notifications, unread_count }
  const resp = await api.get(`/admin/notifications/${id}`);
  return resp.data;
}

export async function markNotificationViewed(id) {
  const resp = await api.post(
    `/admin/notifications/${id}/view`,
    {},
    { skipAuthRedirect: true }
  );
  return resp.data;
}
